// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2Glu1","emails":"CreateEditClinics_emails__3aG7e","emailTagLabel":"CreateEditClinics_emailTagLabel__3T7JP"};